
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14cnr_gepxe_145",
  "trigger": "awsui_trigger_14cnr_gepxe_179",
  "dropdown": "awsui_dropdown_14cnr_gepxe_182",
  "nowrap": "awsui_nowrap_14cnr_gepxe_193",
  "open": "awsui_open_14cnr_gepxe_196"
};
  